// 图片允许类型
export const IMG_UPLOAD_ALLOW_TYPES = ["image/svg+xml", 'image/jpeg', 'image/png', 'image/gif', 'image/webp', "image/bmp", 
"image/vnd.microsoft.icon"]
export const MODE_ENV = import.meta.env.VITE_MODE_ENV;
// 浏览器地址
export const ETHERSCAN_URL = import.meta.env.VITE_APP_ETHERSCAN_URL
// 网络id
export const NET_ID = Number(import.meta.env.VITE_APP_NET_ID || 1)
// 链名称
export const NET_NAME = import.meta.env.VITE_APP_NET_NAME
// 主题
export const THEME = import.meta.env.VITE_APP_THEME 
// 捆绑操作api
export const BUNDLE_API = import.meta.env.VITE_APP_BUNDLE_API;
// 默认RPC节点
export const DEFAULT_RPC = import.meta.env.VITE_APP_DEFAULT_RPC;
// 代币类型
export const TOKEN_TYPE = import.meta.env.VITE_APP_TOKEN_TYPE;
// // 收款地址
// export const RECEIVER_ADDRESS = import.meta.env.VITE_APP_RECEIVER_ADDRESS;
// // 捆绑买入价格
// export const BUNDLE_BUY_PRICE = Number(import.meta.env.VITE_APP_BUNDLE_BUY_PRICE);
// // 捆绑创建池价格
// export const BUNDLE_CREATE_POOL_PRICE = Number(import.meta.env.VITE_APP_BUNDLE_CREATE_POOL_PRICE);

// 创建流动性并买入收款地址
export const LQ_CREATE_AND_BUY_RECEIVER_ADDRESS = import.meta.env.VITE_APP_LQ_CREATE_AND_BUY_RECEIVER_ADDRESS;
// 创建流动性并买入价格
export const LQ_CREATE_AND_BUY = Number(import.meta.env.VITE_APP_LQ_CREATE_AND_BUY_PRICE);

// 创建流动性收款地址
export const LQ_CREATE_RECEIVER_ADDRESS = import.meta.env.VITE_APP_LQ_CREATE_RECEIVER_ADDRESS;
// 创建流动性价格
export const LQ_CREATE_PRICE = Number(import.meta.env.VITE_APP_LQ_CREATE_PRICE);

// meme交易收款地址
export const MEME_SWAP_RECEIVER_ADDRESS = import.meta.env.VITE_APP_MEME_SWAP_RECEIVER_ADDRESS;
// meme交易价格
export const MEME_SWAP_PRICE = Number(import.meta.env.VITE_APP_MEME_SWAP_PRICE);
// 市值管理最佳路由收款地址
export const AUTO_SWAP_RECEIVER_ADDRESS = import.meta.env.VITE_APP_AUTO_SWAP_RECEIVER_ADDRESS;
// 市值管理自动找到最佳路由并交易服务费比例
export const AUTO_SWAP_FEE_RATE = Number(import.meta.env.VITE_APP_AUTO_SWAP_FEE_RATE);
// 是否使用动态地址接收服务费
export const USE_DYNAMIC_SERVICE_FEE_RECEIVER_ADDRESS = Number(import.meta.env.VITE_APP_USE_DYNAMIC_SERVICE_FEE_RECEIVER_ADDRESS);

export const DEXSCREENER_LINK = "https://dexscreener.com"

export const CDN_BASE = import.meta.env.VITE_APP_CDN_BASE;

export const API_OKX_PROJECT = import.meta.env.VITE_API_OKX_PROJECT;
export const API_OKX_KEY = import.meta.env.VITE_API_OKX_KEY;
export const API_OKX_PASSPHRASE = import.meta.env.VITE_API_OKX_PASSPHRASE;
export const API_OKX_SECREKEY = import.meta.env.VITE_API_OKX_SECREKEY;